import {Injectable} from '@angular/core';
import {AuthService} from 'app/core/services/auth.service';
import {map, pluck, take} from 'rxjs/operators';
import {currentUser_currentUser_notifications, currentUser_currentUser_notifications_nodes} from 'app/core/services/gql/currentUser';
import {Observable} from 'rxjs';
import {gql} from 'apollo-angular';
import {ApiService} from 'app/shared/modules/api/services/api.service';
import {deleteNotification} from './gql/deleteNotification';

export const notificationsQuery = gql`
    query notificationsUser($page: Int, $pageSize: Int) {
        currentUser {
            notifications(page: $page, pageSize: $pageSize) {
                nodes {
                    createdAt
                    id
                    isRead
                    subject
                    url
                    canBeDeleted
                }
                pageInfo {
                    currentPage
                    pageSize
                    totalPages
                }
                totalCount
                unreadCount
            }
        }
    }
`;

export const markNotificationAsReadMutation = gql`
    mutation markNotificationAsRead($id: ID!) {
        markNotificationAsRead(id: $id)
    }
`;

export const deleteNotificationMutation = gql`
    mutation deleteNotification($id: ID!) {
        deleteNotification(id: $id)
    }
`;

export type Notifications = currentUser_currentUser_notifications;
export type NotificationsNodes = currentUser_currentUser_notifications_nodes;

@Injectable()
export class NotificationsService {
    constructor(
        private auth: AuthService,
        private api: ApiService
    ) {}

    getNotificationsFromCurrentUser(): Observable<Notifications> {
        return this.auth.currentUser$.pipe(
            take(1),
            map(currentUser => currentUser.notifications)
        );
    }

    fetchNotifications(page: number, pageSize: number): Observable<Notifications> {
        return this.api
            .query<any>({
                query: notificationsQuery,
                variables: {
                    page,
                    pageSize,
                },
                fetchPolicy: 'no-cache',
            })
            .pipe(pluck('currentUser', 'notifications'));
    }

    watchNotification(id: string): Observable<boolean> {
        return this.api.mutate<boolean>({
            mutation: markNotificationAsReadMutation,
            variables: {
                id,
            },
        });
    }

    deleteNotification(id: string): Observable<deleteNotification> {
        return this.api.mutate<deleteNotification>({
            mutation: deleteNotificationMutation,
            variables: {
                id,
            },
        });
    }
}
